module.exports = __webpack_public_path__ + "img/conversations_logo.2d482305.png";